<template>
  <div class="smartRead-detail-container">
    <viewHeader></viewHeader>
    <div class="content">
      <iframe :src="`${pdfLink}#toolbar=0`" frameborder="0" width="50%" height="100%"></iframe>
      <div class="rside">
        <smartReadComponent
        ref="my-smartread-detail"
        :smartReadHeight="smartReadHeight"
        :quesKeywordsList="quesKeywordsList"
        :messageHistoryList="messageHistoryList"
        @sendMessage="handleSendMessage"
        @messageHistory="handleGetMessageHistory"
        :hasMore="hasMore"
        :isFinishConversation="isFinishConversation">
        </smartReadComponent>
      </div>
      <!-- <p class="return-icon">
        <em class="el-icon-back"></em>
      </p> -->
    </div>
  </div>
</template>

<script>
import { fetchEventSource } from '@microsoft/fetch-event-source';
import viewHeader from './viewHeader';
import smartReadComponent from '../components/smartRead/smartRead.vue';
import { webTrackerEvent,webTracker } from '../utils/tracker';
import { checkArticleData,generateQuesKeywords,articleConversationHistory } from '../service/getData';
import { baseURL } from '../config/request';
import axios from 'axios'
export default {
  name: "conversation",
  components: {
    viewHeader,
    smartReadComponent
  },
  data() {
    return {
      smartReadHeight: 'calc(100% - 90px)',
      quesKeywordsList: {},
      messageHistory: [],
      messageHistoryList: [], // 聊天记录
      limit: 10,
      offset: 0, // 记录的偏移量 如：offset就是0，然后limit=10，就是取10条。然后再往上翻，就是offset=10, limit仍然是10
      last_message_id: '', // 上次返回的最后⼀一条消息的id，如果是第⼀一次请求，则不不传。
      hasMore: true, // 是否有更多记录
      pmcid: '',
      hasPDF: true, // 是否存在pdf
      pdfLink: '',
      isFinishConversation: true
    }
  },
  methods: {
    /**
     * 获取文献pdf
    */
    getArticlePDF() {
      axios.get('/pmc/utils/oa/oa.fcgi?id='+this.pmcid+'&format=pdf',{}).then(res => {
        if (res.data.indexOf('link') != -1) {
          let xmldoc;
          if (window.DOMParser) {
            let parser = new DOMParser();
            xmldoc = parser.parseFromString(res.data, 'text/xml');
            parser.parse;
          } else {
            xmldoc = new ActiveXObject("Microsoft.XMLDOM");
            xmldoc.async = 'false';
            xmldoc.loadXML(res.data);
          }

          let aLink = xmldoc.getElementsByTagName('link')[0];
          let aLink_href = aLink.getAttribute('href');
          let aLink_href_arr = aLink_href.split(':');
          this.pdfLink = 'https:'+aLink_href_arr[1];
          // console.log(this.pdfLink);
        } else {
          console.log('no link', res);
        }
      })
    },
    /**
     * 开始聊天
    */
    handleFormatData() {
      let dateJson = {};
      this.messageHistoryList = [];
      this.messageHistory.forEach(item => {
        let date = item.timestamp.split(' ')[0];
        if (!dateJson[date]) {
          dateJson[date] = [];
        }
      });
      if (this.messageHistoryList.length == 0) {
        this.messageHistoryList.unshift(dateJson);
      } else {
        // 否则，遍历要添加的对象
        Object.keys(dateJson).forEach(key => {
          this.messageHistoryList.filter(item => {
            if (!item[key]) {
              item[key] = []
            }
          })
        })
      }

      this.messageHistory.forEach(item => {
        let date = item.timestamp.split(' ')[0];
        this.messageHistoryList.filter(item2 => {
          if (item2[date]) {
            item2[date].push(item)
          }
        })
      })
    },
    async handleSendMessage(data) {
      let date = this.handleFormatDate();
      this.messageHistory.push(
        {
          role: 'user',
          content: data,
          loading: false,
          timestamp: date
        },
        {
          role: 'assistant',
          content: '',
          loading: true,
          timestamp: date
        }
      )
      this.handleFormatData();

      this.$nextTick(() => {
        this.$refs['my-smartread-detail'].$el.scrollTop = this.$refs['my-smartread-detail'].$el.scrollHeight;
      })

      let params = {
        paper_id: this.PMID, // pmid
        target: 'full_text', // "full_text" - 基于整个论⽂聊；"section" - 基于某个section聊，目前只能传full_text
        text: data,
        stream: true // true - 使⽤ stream 模式; false - 使⽤⾮ stream 模式。
      }

      // 建立 FETCH-SSE 连接
      let controller = new AbortController();
      let content = '';
      fetchEventSource(baseURL+'/conversation', 
        {
          method: 'POST', 
          body: JSON.stringify(params),
          signal: controller.signal,
          headers: {
            'Content-Type': 'application/json', 
            'Accept': '*/*',
            'Authorization': localStorage.getItem('PUBMEDSEARCHTOKEN')
          },
          onopen: () => {
            console.log('连接成功');
          },
          onclose: () => {
            console.log('连接关闭');
          },
          onmessage: (msg) => {
            this.$nextTick(() => {
              this.$refs['my-smartread-detail'].sendLoading = false;
            })
            let current2= [];
            this.messageHistoryList.filter(item => {
              current2 = item[date]
            });
            let index2 = current2.length-1;
            let current = this.messageHistory[this.messageHistory.length - 1];
            let index = this.messageHistory.length-1;

            if (!msg) return;
            const dataText = JSON.parse(msg.data);
            this.isFinishConversation = false; // 是否结束对话
            // 结束
            if (dataText.type == 'finished_answer') { 
              this.$set(current, 'loading', false);
              this.$set(current2[index2], 'loading', false);
              this.messageHistoryList.filter(item => {
                if (item[date]) {
                  item[date] = current2
                }
              });
              this.$set(this.messageHistory, index, current);
              closeSSE();
              return
            }

            // 持续输出
            if (dataText.type == 'new_token') {
              content += dataText.text;
              this.$set(current, 'content', content);
              this.$set(current, 'loading', false);
              this.$set(current2[index2], 'content', content);
              this.$set(current2[index2], 'loading', false);
              this.messageHistoryList.filter(item => {
                if (item[date]) {
                  item[date] = current2
                }
              });
              this.$set(this.messageHistory, index, current);
              this.$nextTick(() => {
                this.$refs['my-smartread-detail'].$el.scrollTop = this.$refs['my-smartread-detail'].$el.scrollHeight;
              })
            }
          },
          onerror: (e) => {
            console.log(e)
          }
        }
      );

      // 断开 FETCH-SSE 连接
      const closeSSE = () => {
        if (controller) {
          controller.abort()
          controller = undefined
          console.log('FETCH 连接关闭');
          this.isFinishConversation = true
        }
      }
    },
    /**
     * 获取论文聊天历史
    */
    async handleGetMessageHistory(initial = true) {
      this.$nextTick(() => {
        this.$refs['my-smartread-detail'].messageLoading = true;
      })
      let params = {
        paper_id: this.PMID,
        target: 'full_text', // "full_text" - 基于整个论⽂聊；"section" - 基于某个section聊，目前只有full_text
        limit: this.limit, // 返回的最⼤记录数
        // offset: this.offset // 返回的记录偏移量
      }
      if (this.last_message_id != '') {
        params.last_message_id = this.last_message_id
      }

      let res = await articleConversationHistory(params)
      this.$nextTick(() => {
        this.$refs['my-smartread-detail'].messageLoading = false;
      })
      if (res.data.status == 0) {
        let { history } = res.data;
        if (history.length > 0) {
          this.hasMore = true;
          // this.offset += 10;
          this.last_message_id = history[0].message_id;
          this.messageHistory = history.concat(this.messageHistory);

          this.handleFormatData();

          if (initial) {
            this.$nextTick(() => {
              this.$refs['my-smartread-detail'].$el.scrollTop = this.$refs['my-smartread-detail'].$el.scrollHeight;
            })
          }
        } else {
          this.hasMore = false
        }
      } else {
        this.messageHistoryList = []
      }
    },
    /**
     * 转日期
    */
    handleFormatDate() {
      let timestamp = new Date();
      let year = timestamp.getFullYear();
      let month = (timestamp.getMonth() + 1) < 10 ?  '0'+(timestamp.getMonth() + 1) : timestamp.getMonth() + 1;
      let date = timestamp.getDate() < 10 ? '0'+timestamp.getDate() : timestamp.getDate();
      return year+'-'+month+'-'+date
    },
    // handleSmartRead() {
    //   this.drawer = true;
    //   this.$nextTick(() => {
    //     this.handleGenerateQuesKeywords();
    //     this.handleGetMessageHistory();
    //   })
    // },
    /**
     * 根据论文生成若干问题和关键词
    */
    async handleGenerateQuesKeywords() {
      if (this.quesKeywordsList['questions'] && this.quesKeywordsList['keywords']) {
        return
      }
      this.$nextTick(() => {
        this.$refs['my-smartread-detail'].keywordsLoading = true;
      })
      let params = {
        paper_id: this.PMID, // pmid
        question_amount: 3, // 需要⽣成的问题数，暂定最多10个
        keyword_amount: 5, // 需要⽣成的关键词数，暂定最多10个
        type: 'abstract', // ⽣成类型："abstract" - 根据论⽂摘要⽣成；"section" - 根据section摘要⽣成，目前只能传abstract
      }
      let res = await generateQuesKeywords(params)
      this.$nextTick(() => {
        this.$refs['my-smartread-detail'].keywordsLoading = false;
      })
      if (res.data.status == 0) {
        let { keywords, questions } = res.data;
        this.quesKeywordsList['questions'] = questions;
        this.quesKeywordsList['keywords'] = keywords;
      }
    },
    /**
     * 检查论文是否已上传
    */
    async handleCheckArticleData() {
      let params = {
        pmid: this.PMID
      }
      let res = await checkArticleData(params)
      if (res.data.status == 0) {
        this.handleGenerateQuesKeywords();
        this.handleGetMessageHistory();
      }
    },
  },
  created() {
    this.PMID = this.$route.query.pmid;
    this.pmcid = this.$route.query.pmcid;
    this.handleCheckArticleData();
    this.getArticlePDF()
  }
};
</script>

<style scoped lang="less">
  .smartRead-detail-container{
    background: #f9f9f9;
    height: 100vh;
    .content{
      display: flex;
      height: calc(100% - 80px);
      width: 1080px;
      margin: 0 auto;
      box-shadow: 0 4px 10px #eee;
      position: relative;
      .rside{
        position: relative;
        background: #F7F7F8;
        flex: 1;
      }
      .return-icon{
        width: 32px;
        height: 32px;
        background: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 4px;
        left: -40px;
        box-shadow: 0px 2px 5px 0px rgba(6,25,56,0.06);
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/conversation.vue